import { Skeleton, Stack } from "@chakra-ui/react";

interface LoadingIndicatorProps {
  lines?: number;
}

export const LoadingIndicator = ({ lines=4 }: LoadingIndicatorProps) => (
  <Stack gap="2">
    {[...Array(lines - 1).keys()].map((i) => <Skeleton key={i} h="6" /> )}
    <Skeleton h="6" w="80%" />
  </Stack>);
